import styled from 'styled-components';

const TagText = styled.div`
  font-size: 10px;
  margin-top: ${({ theme }) => theme.spacing(1)};
`;

export default TagText;
